import { render } from "./EmergencyContacts.vue?vue&type=template&id=2f382e14"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__